import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';


import { analyticListSelector } from 'store/analytic/selectors';
import { Analytic } from 'store/analytic/actions';

import { Portal } from 'components/Portal';
import { Loader } from 'components/Loader';

import './style.scss';
import { InputRangeDatePicker } from 'components/InputRangeDatePicker/InputRangeDatePicker';

const ModalStatistic = ({ onClose }) => {
  const dispatch = useDispatch();

  const [calendarVisible, setCalendarVisible] = useState(false);

  const analyticList = useSelector(analyticListSelector);

  const [pending, setPending] = useState(false);

  useEffect(() => {
    dispatch(Analytic.getAnalyticList());
  }, [onClose]);

  const handleFilterByDate = ({ from, to } = {}) => {
    setCalendarVisible(false);

    if (!from & !to) {
      dispatch(Analytic.getAnalyticList({}));
    } else {
      dispatch(
        Analytic.getAnalyticList({
          date_before: new Date(+to).toISOString(),
          date_after: new Date(+from).toISOString(),
        })
      );
    }
  };

  return (
    <Portal id='modal-statistic' className="analytic" onClose={onClose}>
      <div className="modal-title">
        <div className="header-title-analytic">
          {' '}
          <b> Статистика</b>
        </div>
      </div>
      <div className="analytic-list dropdownScroll">
        {analyticList &&
          analyticList.map((analytic, i) => (
            <div key={analytic.step_name} className="analytic-select">
              <div className="analytic-data">
                <div className="analytic-name">{analytic.step_name}</div>{' '}
                <div>
                :  <b> { analytic.step_name_count.toLocaleString('ru')}</b> ({analytic.step_name_percent}%)
                </div>
              </div>
            </div>
          ))}

        {analyticList === null && <Loader type="small" color="#000" />}
      </div>
      <InputRangeDatePicker handleFilter={handleFilterByDate} boxShadow={false} close={() => setCalendarVisible(false)} />
    </Portal>
  );
};

ModalStatistic.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export { ModalStatistic };
